import {aboutusdata} from '../data'
import Card from '../UI/Card'
import {Link} from 'react-router-dom'

const AboutUs = () => {
  return (
    <section className='aboutus'>
        <div className="container aboutus-container">
            <div className="aboutus-left">
                <h4>SINCE 2017</h4>
                <h1>About Us</h1>
                <p>
                    We're an easy-going, professional bunch who take great pride in our work. We are experts in our fields. Years of experience and a handful of networks might give you the results of the advanced technology you need.
                </p>
                <Link to="/about" className='trans_btn md'>WHO WE ARE</Link>
            </div>
            <div className='aboutus-mid' />
            <div className="aboutus-right">
                <h2>LeaderShip</h2>
                <ul className='leadership-list'>
                {
                    aboutusdata.map(({index, icon, name, title}) => {
                        return (
                            <li className='' key={index}>
                                <Card className="">
                                    <div className="aboutus__avatar">
                                        <img src={icon} alt={name} />
                                    </div>
                                    <h4>{name}</h4>
                                    <p>{title}</p>
                                </Card>
                            </li>
                        )
                    })
                }
                </ul>
            </div>
        </div>
    </section>
  )
}

export default AboutUs